import { CircleHelp } from 'lucide-react';
import {
  Tooltip as UITooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

// Matches the tooltip style used in Stats.tsx (CircleHelp icon, default
// TooltipContent styling). Long text wraps inside a capped width instead of
// stretching into one very long line that spills over the neighbouring card.
//   <InfoTooltip text="What this metric means." />
export function InfoTooltip({ text }) {
  return (
    <TooltipProvider>
      <UITooltip>
        <TooltipTrigger asChild>
          <CircleHelp className="h-5 w-5 text-muted-foreground no-export" />
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="end"
          collisionPadding={12}
          className="max-w-[min(320px,calc(100vw-24px))] whitespace-normal break-words text-left leading-snug"
        >
          <p>{text}</p>
        </TooltipContent>
      </UITooltip>
    </TooltipProvider>
  );
}